/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type BulkReleaseDetailItem = {
    payoutNumber: string;
    status: BulkReleaseDetailItem.status;
    reason?: string;
};
export namespace BulkReleaseDetailItem {
    export enum status {
        RELEASED = 'released',
        FAILED = 'failed',
        SKIPPED = 'skipped',
    }
}

